import DatePicker from "react-datepicker";
import styled from "styled-components";
import Select from "react-select";

export const FormContainer = styled.div`
  .form {
    justify-content: center;
    padding: 20px;
    width: 100%;
    position: relative;

    .react-datepicker-wrapper {
      width: 100% !important; /* Ensure the wrapper around the date picker takes full width */
    }
  }

  .label-title {
    margin-bottom: 0.5rem;
    font-weight: 700;
    color: #58585b;
    font-size: 0.875rem;
  }
  .error {
    .css-13cymwt-control {
      border-color: #ae1515;
    }
    color: #ae1515;
    &.text-area {
      border: 1px solid #ae1515;
      border-radius: 5px;
    }
  }

  @media only screen and (max-width: 800px) {
    .error {
      font-size: 0.75rem !important;
    }
  }
  .required {
    display: flex;
    color: #ae1515;
    font-size: 0.9375rem;
    gap: 5px;
    margin-left: 5px;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  min-height: 38px;
  outline: 0 !important;
  background-color: ${(props) => (props.disabled ? "rgb(243, 243, 243)" : "hsl(0, 0%, 100%)")};
  border-radius: 7px;
  border: 1px solid rgb(223, 228, 234);
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  width: 100% !important;
  font-size: 0.875rem;
  padding-left: 10px;
  color: rgb(99, 115, 129);

  &:disabled {
		-webkit-appearance: none !important;
		appearance: none !important;
		background-color: #f3f3f3 !important;
		background-image: linear-gradient(to right, #f3f3f3, #f3f3f3) !important;
		color: rgb(99, 115, 129) !important;
		-webkit-text-fill-color: rgb(99, 115, 129) !important;
		opacity: 1 !important;
		pointer-events: none;
	}
`;

export const CustomBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
